import React from "react";
import podiumModeHelp from "images/podiumModeHelp.png";

const HlpShout = () => {
  return (
    <>
      <h1>Turn On Podium mode</h1>
      Podium mode will project your audio and video to everyone in the space.
      <img style={{ margin: 0 }} src={podiumModeHelp} alt="podium mode" />
    </>
  );
};

export default HlpShout;
